<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <p class="title">
          {{`添加${title}`}}
        </p>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="number">
        <span class="required">*</span>
        <div class="inputer">
          <input type="text" :placeholder="`请输入${title}编号`" v-model="info.number">
        </div>
      </div>
      <div class="detail">
        <div class="item">
          <span class="required">*</span>
          <span class="name">分类</span>
          <span class="input select">
            <select class="" v-model="baseInfo.id">
              <option :value="b.id" v-for="(b, i) in bases" :key="i">{{b.title}}</option>
            </select>
            <img src="../assets/img/resources/down.svg" alt="down" class="down">
          </span>
        </div>
        <div class="item">
          <span class="required">*</span>
          <span class="name">类型</span>
          <span class="input select">
            <select v-model="classInfo.id">
              <option :value="c.id" v-for="(c, i) in classes">{{c.title}}</option>
            </select>
            <img src="../assets/img/resources/down.svg" alt="down" class="down">
          </span>
        </div>
        <!-- <div class="item" v-if="type === 1">
          <span class="required">*</span>
          <span class="name">类型</span>
          <span class="input">
            <select>
              <option value="1">司机</option>
            </select>
            <img src="../assets/img/resources/down.svg" alt="down" class="down">
          </span>
        </div> -->
        <div class="item" v-if="type === 2">
          <span class="required">*</span>
          <span class="name">名称</span>
          <span class="input">
            <input type="text" v-model="device.name">
          </span>
        </div>
        <div class="item" v-if="type === 1">
          <span class="required">*</span>
          <span class="name">姓名</span>
          <span class="input">
            <input type="text" v-model="people.name">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">存放位置</span>
          <span class="input">
            <input type="text" v-model="device.locate">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">单价</span>
          <span class="input">
            <input type="text" v-model="device.price">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">报价单位</span>
          <span class="input">
            <input type="text" v-model="device.seller">
          </span>
        </div>
        <div class="item" v-if="type === 1">
          <span class="required"></span>
          <span class="name">手机</span>
          <span class="input">
            <input type="text" v-model="people.tel">
          </span>
        </div>
        <!-- <div class="item long" v-if="type === 1 && classInfo.id == '6'"> -->
        <div class="item long" v-if="type === 1 && classInfo.id == '6'">
          <span class="required"></span>
          <span class="name">配置车辆</span>
          <span class="input select">
            <!-- <input type="text" v-model="people.bus"> -->
            <select class="" v-model="people.bus" @change="changeBus">
              <option :value="0" disabled selected>请选择</option>
              <option :value="b.id" v-for="(b, i) in buses">{{b.title}}</option>
            </select>
            <span class="stxt">选择</span>
          </span>
          <span class="notice" v-if="selectedBus.isbusy">
            <img src="@assets/img/interview/alert.svg" alt="alert">
            <span>该车已有绑定人员</span>
          </span>
        </div>
      </div>
      <div class="remark">
        <textarea placeholder="备注" v-model="info.remark" maxlength="200">
        </textarea>
        <span class="count">{{`${info.remark.length}/200`}}</span>
      </div>
      <div class="btn" @click="addResource()">
        保存
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
export default {
  name: 'addResource',
  data() {
    return {
      show: false,
      type: 1,
      types: [  // 资源类型
        {
          t: 1,
          name: '人员'
        },
        {
          t: 2,
          name: '设备'
        }
      ],
      info: {  // 基础信息
        number: '',
        remark: ''
      },
      device: {  // 设备信息
        name: '',
        locate: '',
        price: '',
        seller: ''
      },
      people: {  // 人员信息
        name: '',
        tel: '',
        bus: '0'
      },
      bases: [],  // 分类数据
      classes: [],  // 类型数据
      baseInfo: {  // 分类已选信息
        id: '',
        title: ''
      },
      classInfo: {  // 类型已选信息
        id: '',
        title: ''
      },
      buses: [],  // 弹窗为‘人员’且类型是‘司机’时，供选车辆数据
      selectedBus: {  // buses中已选车辆数据
        id: '',
        isbusy: false
      }
    }
  },
  computed: {
    baseId() {
      // 将baseInfo中的id抽出来watch，防止为baseInfo赋值导致变化
      return this.baseInfo.id
    }
  },
  watch: {
    baseId: {
      deep: true,
      handler: function(n, o) {
        this.changeClasses(n)
      }
    },
    classInfo: {
      deep: true,
      handler: function(n, o) {
        // this.getBuses()
        if(n.id - 0 === 6) {
          this.getBuses()
        }
      }
    }
  },
  methods: {
    changeBus(e) {
      // 切换人员配置采访车
      const id = e.target.value
      this.buses.forEach((i) => {
        if (i.id == id) {
          this.$set(this.selectedBus, 'id', i.id)
          this.$set(this.selectedBus, 'isbusy', !!i.person_id)
        }
      })
    },
    getBuses() {
      // 获取采访车列表
      common.myFetch(apis.Res_bus_list, {})
      .then((data) => {
        this.buses = data.list
      })
    },
    changeClasses(s) {
      // 切换分类，分类和类型联动，默认选择类型第一项
      this.bases.forEach((i) => {
        if (s === i.id) {
          this.classes = i.list
          this.$set(this.classInfo, 'id', this.classes[0].id)
        }
      })
    },
    resetData() {
      this.info = {
        number: '',
        remark: ''
      }
      this.device = {
        name: '',
        locate: '',
        price: '',
        seller: ''
      }
      this.people = {
        name: '',
        tel: '',
        bus: '0'
      }

      this.bases = []
      this.classes = []
      this.buses = []
      this.baseInfo = {
        id: '',
        title: ''
      }
      this.classInfo = {
        id: '',
        title: ''
      }
      this.selectedBus = {
        id: '',
        isbusy: false
      }
    },
    open(t) {
      // 打开弹窗方法
      this.resetData()
      this.type = t
      this.watchType()
      this.fill()
      this.show = true
    },
    close() {
      // 关闭方法
      this.show = false
    },
    watchType() {
      // 根据类型匹配title
      const t = this.type
      this.types.forEach((i) => {
        if (i.t === t) {
          this.title = i.name
        }
      })
    },
    async addResource() {
      // 根据类型提交数据
      let done = false

      if (this.type === 1) {
        done = await this.addPeople()
      } else {
        done = await this.addDevice()
      }
      if (done) {
        this.close()
      }
    },
    addPeople() {
      // 提交添加人员数据
      const idstring = this.info.number
      const remark = this.info.remark
      const class_id = this.baseInfo.id
      const class_title = this.bases.map(i => {return i.id === class_id ? i.title : ''}).join('')
      const type_id = this.classInfo.id
      const type_title = this.classes.map(i => {return i.id === type_id ? i.title : ''}).join('')
      const title = this.people.name
      const phone = this.people.tel
      const bus = this.people.bus

      const info = {
        idstring: idstring,
        class_id: class_id,
        class_title: class_title,
        type_id: type_id,
        type_title: type_title,
        remark: remark,
        title: title,
        phone: phone,
        bus: bus
      }

      return common.myFetch(apis.Res_people_add, info)
      .then((data) => {
        if (data) {
          this.$toast(data)

          return true
        }

        return false
      })
    },
    addDevice() {
      // 提交添加设备数据
      const idstring = this.info.number
      const remark = this.info.remark
      const class_id = this.baseInfo.id
      const class_title = this.bases.map(i => {return i.id === class_id ? i.title : ''}).join('')
      const type_id = this.classInfo.id
      const type_title = this.classes.map(i => {return i.id === type_id ? i.title : ''}).join('')
      const title = this.device.name
      const location = this.device.locate
      const price = this.device.price
      const price_unit = this.device.seller

      const info = {
        idstring: idstring,
        class_id: class_id,
        class_title: class_title,
        type_id: type_id,
        type_title: type_title,
        remark: remark,
        title: title,
        location: location,
        price: price,
        price_unit: price_unit
      }

      return common.myFetch(apis.Res_device_add, info, 'post')
      .then((data) => {
        if (data) {
          this.$toast(data)

          return true
        }

        return false
      })
    },
    fill() {
      // 获取填充数据
      const info = {
        page_type: this.type
      }

      common.myFetch(apis.Res_resource_add_fill, info)
      .then((data) => {
        this.bases = data
        this.$set(this.baseInfo, 'id', this.bases[0].id)
        this.classes = this.bases[0].list
        this.$set(this.classInfo, 'id', this.classes[0].id)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1200;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    height: 600px;
    padding: 20px 30px;
    .headline {
      height: 34px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        cursor: pointer;
      }
    }
    .required {
      color: @red;
      width: 10px;
      font-size: 24px;
      font-family: Helvetica, sans-serif;
      margin-right: 10px;
    }
    .number {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .inputer {
      flex: 1;
      height: 40px;
      border-radius: 4px;
      background-color: rgba(185, 195, 195, 0.2);
      display: flex;
      padding: 10px 20px;
      margin-bottom: 13px;
      input {
        background-color: transparent;
        flex: 1;
        font-size: 14px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
          font-size: 14px;
        }
      }
    }
    .detail {
      padding-bottom: 7px;
      border-bottom: 1px solid #dcdcdc;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .item {
        width: 50%;
        margin: 13px 0;
        height: 30px;
        display: flex;
        align-items: center;
        .name {
          width: 52px;
          font-size: 14px;
          color: @sub;
          text-align-last: justify;
          margin-right: 30px;
          word-break: keep-all;
        }
        .input {
          box-sizing: border-box;
          width: 180px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #dcdcdc;
          padding-left: 38px;
          font-size: 14px;
          color: @dark;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          overflow: hidden;

          &.select {
            position: relative;
            padding: 0;
          }

          select {
            font-size: 14px;
            height: 100%;
            width: 100%;
            border: none;
            outline: none;
            padding-left: 38px;
            box-sizing: border-box;
            background: transparent;
          }
          input {
            font-size: 14px;
            height: 100%;
            flex-grow: 1;
            flex-shrink: 1;
            box-sizing: border-box;
            background-color: transparent;
          }
          .down {
            position: absolute;
            right: 10px;
          }
        }
      }
      .item:nth-child(2n) {
        justify-content: flex-end;
      }
      .long {
        width: 100% !important;
        justify-content: flex-start !important;
        .stxt {
          width: 30px;
          flex-shrink: 0;
          font-size: 14px;
          color: @green;
          cursor: pointer;
        }
        input {
          max-width: 100px;
        }
        .notice {
          display: flex;
          font-size: 14px;
          color: @sub;
          img {
            margin: 0 6px 0 10px;
          }
        }
      }
    }
    .remark {
      height: 200px;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      margin: 20px 0;
      padding: 14px 20px 28px;
      position: relative;
      textarea {
        width: 100%;
        height: 100%;
        background-color: transparent;
        resize: none;
        font-size: 16px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
        }
      }
      .count {
        font-size: 16px;
        color: @dateColor;
        bottom: 8px;
        right: 18px;
        position: absolute;
      }
    }
    .btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 100px;
      background-color: @green;
      color: #fff;
      font-size: 14px;
      margin: 0 auto;
      cursor: pointer;

      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
  }
}
</style>
